<template>
    <div>
        <div class="col-12 form-group">
            <label for="articleSearch">
                Search for article{{ maxArticlesCount > 1 ? 's' : '' }}
            </label>
            <div class="article-chooser">
                <div class="article-select">
                    <v-select
                        v-model="selectedArticle"
                        label="name"
                        :clearable="false"
                        :options="articlesOptions"
                        @search="onArticleSearch"
                    >
                        <template #no-options="{ search }">
                            {{
                                search
                                    ? 'Sorry, no matching options.'
                                    : 'Type to search...'
                            }}
                        </template>
                    </v-select>
                </div>
                <button
                    class="col-1 btn btn-success waves-effect waves-light"
                    type="button"
                    :disabled="isAddButtonDisabled"
                    @click="addArticle"
                >
                    <i class="fas fa-plus-circle" />
                </button>
            </div>
        </div>

        <div v-if="!!maxArticlesCount" class="col-12">
            You can select up to {{ maxArticlesCount }} article{{
                maxArticlesCount > 1 ? 's' : ''
            }}.
        </div>

        <awesome-table
            v-if="articles.length"
            :labels="labels"
            :items="articles"
            :options="{
                addButton: false,
                pagination: false,
                clickableRows: false,
                searchInput: false,
                isCard: false,
                link: false,
                filters: false,
                refreshButton: false,
                columnsSelector: false
            }"
        >
            <template #[`items.actions`]="{ index }">
                <a
                    href="#"
                    class="action-icon"
                    @click.prevent="deleteArticle(index)"
                >
                    <i class="far fa-trash-alt" />
                </a>
            </template>
        </awesome-table>
        <div v-else class="text-center">
            <span>No articles added yet!</span>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';

export default {
    props: {
        value: {
            type: Array,
            required: true
        },

        filters: {
            type: Object,
            default: () => ({})
        },

        maxArticlesCount: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            labels: [
                {
                    value: 'name',
                    sortable: false,
                    filterable: false
                },
                {
                    value: 'actions',
                    sortable: false,
                    filterable: false
                }
            ],
            articles: cloneDeep(this.value),
            articlesOptions: [],
            defaultArticles: [],
            selectedArticle: null,
            pagination: {
                perPage: 50
            }
        };
    },

    computed: {
        isAddButtonDisabled() {
            return (
                !!this.maxArticlesCount &&
                this.value.length >= this.maxArticlesCount
            );
        }
    },

    async created() {
        try {
            const { rows } = await this.getAvailableArticles({
                filters: this.filters,
                ...this.pagination
            });

            this.defaultArticles = [...rows];
            this.articlesOptions = [...rows];
        } catch (err) {
            console.error(err);
        }
    },

    methods: {
        ...mapActions({
            getAvailableArticles: 'articles/index'
        }),

        async onArticleSearch(search, loading) {
            if (!search.length) {
                this.articlesOptions = this.defaultArticles;

                return;
            }

            if (this.timer) {
                clearTimeout(this.timer);

                this.timer = null;
            }

            loading(true);

            this.timer = setTimeout(async () => {
                try {
                    const { rows } = await this.getAvailableArticles({
                        search,
                        filters: this.filters,
                        ...this.pagination
                    });

                    this.articlesOptions = rows;
                } catch (err) {
                    console.error(err);
                } finally {
                    loading(false);
                }
            }, 500);
        },

        addArticle() {
            const isAlreadyAdded = this.articles.find(
                article => this.selectedArticle.id === article.id
            );

            if (isAlreadyAdded) {
                this.$bvToast.toast('Article has already been added!', {
                    title: 'Warning!',
                    variant: 'warning',
                    solid: true
                });

                return;
            }

            this.articles.push({ ...this.selectedArticle });

            this.$emit('on-articles-change', this.articles);

            this.selectedArticle = null;
        },

        deleteArticle(index) {
            this.articles.splice(index, 1);

            this.$emit('on-articles-change', this.articles);
        }
    }
};
</script>
